var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6294 14.2136C53.8513 14.8201 55.6089 16.6061 56.2058 18.8637C57.3001 22.9748 57.3333 31.5001 57.3333 31.5001C57.3333 31.5001 57.3333 40.0592 56.2389 44.1365C55.642 46.3942 53.8844 48.1802 51.6626 48.7867C47.6499 49.8987 31.5 49.8987 31.5 49.8987C31.5 49.8987 15.35 49.8987 11.3374 48.7867C9.11549 48.1802 7.3579 46.3942 6.76098 44.1365C5.66663 40.0255 5.66663 31.5001 5.66663 31.5001C5.66663 31.5001 5.66663 22.9748 6.72781 18.8975C7.32473 16.6398 9.08233 14.8538 11.3042 14.2473C15.3168 13.1353 31.4668 13.1016 31.4668 13.1016C31.4668 13.1016 47.6168 13.1016 51.6294 14.2136ZM39.7242 31.5002L26.3267 39.3853V23.615L39.7242 31.5002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.765c4826b8841903a22615b362d84a68.svg";
export { ForwardRef as ReactComponent };